import { Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const FilterDisplay = ({ filterOptions, origin }) => {

    const { agentAndDelegates } = useSelector((state) => state.account);
    const { status, like, priority, startDate, endDate } = useSelector((state) => state.bugReport);

    const filters = origin === "bugs"
  ? [
      status,
      like === true ? "Liked" : like === false ? "Disliked" : null,
      priority,
      startDate,
      endDate,
    ].filter(Boolean)
  : [];
    let selectedRoles, selectedSortBy, selectedSortOrder, filterStatus;

    if (origin === "contacts") {
        ({ selectedRoles, selectedSortBy, selectedSortOrder, filterStatus } = filterOptions || {});
    }
    const contactFilters = origin === "contacts" ? [selectedRoles,selectedSortBy,selectedSortOrder,filterStatus].filter(Boolean) : [];

    console.log(filters, "20")

    return <>
        {origin === "bugs" ?
            filters?.map((filter, index) => (
                <Tag
                    style={{
                        padding: "2px 8px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        margin: "2px",
                        borderRadius: "16px",
                        lineHeight: "20px",
                    }}
                    key={index}
                    color="blue"
                >
                    {filter}
                </Tag>
            )) :
            origin === "contacts" ? contactFilters?.flatMap((filter) =>
            Array.isArray(filter) ? filter : [filter]
          ).map((item, index) => (
            <Tag
              style={{
                padding: "2px 8px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                margin: "2px",
                borderRadius: "16px",
                lineHeight: "20px",
              }}
              key={index}
              color="blue"
            >
              {item}
            </Tag>
            )) :
            origin === "calendar" ? agentAndDelegates?.filter((el) => el?.selected)?.map((agent,index) => (
                <Tag
                    style={{
                        padding: "2px 8px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        margin: "2px",
                        borderRadius: "16px",
                        lineHeight: "20px",
                    }}
                    key={index} color="blue"
                >
                    <span>{agent?.fullName}</span>
                </Tag>
            ))
            :
            origin !== "template" ? filterOptions?.map((option, index) => (
                <Tag
                    style={{
                        padding: "2px 8px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        margin: "2px",
                        borderRadius: "16px",
                        lineHeight: "20px",
                    }}
                    key={index} color="blue"
                >
                    <span>{option}</span>
                </Tag>
            )) :
                filterOptions?.anyFilterApplied && <Tag
                    style={{
                        padding: "2px 8px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        margin: "2px",
                        borderRadius: "16px",
                        lineHeight: "20px",
                    }} color="blue"
                >
                    <span>{filterOptions?.selectedContractType}</span>
                </Tag>}
    </>
}

export { FilterDisplay }